import { FC } from "react"

import { ReactComponent as IconAnonymous } from "@common_assets/svg/anonymous.svg"
import { Button, Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

interface IProps {
  onImportGroup: () => void
  onCreateGroup: () => void
}

const GroupsEmptyState: FC<IProps> = ({ onImportGroup, onCreateGroup }) => {
  const { t } = useTranslation()

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      gap="8px"
      width="100%"
      maxWidth={{ desktop: "800px" }}
      mx="auto"
      minHeight={{
        mobile: "calc(100vh - 240px)",
        tablet: "calc(100vh - 260px)",
        desktop: "calc(100vh - 340px)",
      }}
      p="32px"
      border={(theme) => `2px solid ${theme.palette.mockup.primary95}`}
      borderRadius="16px"
      bgcolor={(theme) => theme.palette.common.white}
    >
      <IconAnonymous />
      <Typography variant="h3" color="mockup.darkBlue">
        {t("group.emptyTitle")}
      </Typography>
      <Typography variant="body2" color="mockup.neutral40">
        {t("group.emptySubtitle")}
      </Typography>
      <Stack
        direction={{ mobile: "column", tablet: "row" }}
        gap="8px"
        mt="16px"
      >
        <Button variant="outlined" onClick={onImportGroup}>
          {t("group.importGroups")}
        </Button>
        <Button onClick={onCreateGroup}>{t("group.createGroupCta")}</Button>
      </Stack>
    </Stack>
  )
}

export default GroupsEmptyState
